export const dataOptions = {
  maritalStatusOptions: [
    { label: 'form.borrow.maritalStatus.single', value: 'Single' },
    { label: 'form.borrow.maritalStatus.married', value: 'Married' },
    { label: 'form.borrow.maritalStatus.widowed', value: 'Widowed' },
    { label: 'form.borrow.maritalStatus.divorced', value: 'Divorced' }
  ],

  livingOptions: [
    { label_km: '< 6ខែ', label_en: '<6 months', value: '<6 months', id: '6ms' },
    { label_km: '6 ទៅ 12ខែ', label_en: '6 to 12 months', value: '6 to 12 months', id: '6m12m' },
    { label_km: '1 ទៅ 2ឆ្នាំ', label_en: '1 to 2 years', value: '1 to 2 years', id: '1y2y' },
    { label_km: '2 ទៅ 3ឆ្នាំ', label_en: '2 to 3 years', value: '2 to 3 years', id: '2y3y' },
    { label_km: '3 ទៅ 5ឆ្នាំ', label_en: '3 to 5 years', value: '3 to 5 years', id: '3y5y' },
    { label_km: '5 ទៅ 10ឆ្នាំ', label_en: '5 to 10 years', value: '5 to 10 years', id: '5y10y' },
    { label_km: '10+ ឆ្នាំ', label_en: '10+ years', value: '10+ years', id: '10yp' }
  ],

  purchaseItemOptions: [
    { label_km: 'គ្រឿងអេឡិចត្រូនិច - ឧបករណ៍ប្រើប្រាស់', label_en: 'Electronic - Appliances', value: 'Electronic - Appliances', id: 'e-appliances' },
    { label_km: 'គ្រឿងអេឡិចត្រូនិច - ទូរស័ព្ទ', label_en: 'Electronic - Phone', value: 'Electronic - Phone', id: 'e-phone' },
    { label_km: 'គ្រឿងអេឡិចត្រូនិច - ថេប្លេត', label_en: 'Electronic - Tablet', value: 'Electronic - Tablet', id: 'e-tablet' },
    { label_km: 'គ្រឿងអេឡិចត្រូនិច - កុំព្យូទ័រ', label_en: 'Electronic - Computer', value: 'Electronic - Computer', id: 'e-computer' },
    { label_km: 'យានយន្ត - រថយន្ត', label_en: 'Auto - Car', value: 'Auto - Car', id: 'a-car' },
    { label_km: 'យានយន្ត - ម៉ូតូ', label_en: 'Auto - Motorcycle', value: 'Auto - Motorcycle', id: 'a-moto' },
    { label_km: 'អចលនទ្រព្យ - ដី', label_en: 'Real Estate - Land', value: 'Real Estate - Land', id: 're-land' },
    { label_km: 'ផ្សេងទៀត', label_en: 'Other', value: 'Other', id: 'other' }
  ],

  typeOfCollateralOptions: [
    { label_km: 'ប័ណ្ណសម្គាល់រថយន្ត', label_en: 'Car Identification', value: 'Car Identification', id: 'car_id' },
    { label_km: 'ប័ណ្ណសម្គាល់ម៉ូតូ', label_en: 'Motorcycle Identification Card', value: 'Motorcycle Identification Card', id: 'motorcycle_id' },
    { label_km: 'ប័ណ្ណកម្មសិទ្ធិដីធ្លីឬប្លង់ផ្ទះ', label_en: 'Land Title or Home Title', value: 'Land Title or Home Title', id: 'land_home_title' },
    { label_km: 'មូលប្បទានប័ត្រធនាគារ', label_en: 'Bank Cheque', value: 'Bank Cheque', id: 'bank_cheque' },
    { label_km: 'កុំព្យូទ័រ', label_en: 'Computer', value: 'Computer', id: 'computer' },
    { label_km: 'ទូរស័ព្ទ', label_en: 'Phone', value: 'Phone', id: 'Phone' },
    { label_km: 'ផ្សេងទៀត', label_en: 'Other', value: 'Other', id: 'other' }
  ],

  loanTermOptions: [
    { label_km: 'ប្រចាំខែ រហូតដល់ ១២ខែ', label_en: 'Monthly up to 12 months', value: 'Monthly up to 12 months', id: '12month' },
    { label_km: 'ផ្សេងទៀត', label_en: 'Other', value: 'Other', id: 'other' }
  ],

  monthlyIncomeOptions: [
    { label: '< $200', value: '<200', id: 'monthly_income_a' },
    { label: '$200-$250', value: '$200-$250', id: 'monthly_income_b' },
    { label: '$251-$350', value: '$251-$350', id: 'monthly_income_c' },
    { label: '$351-$450', value: '$351-$450', id: 'monthly_income_d' },
    { label: '$451-$600', value: '$451-$600', id: 'monthly_income_e' },
    { label: '$601-$800', value: '$601-$800', id: 'monthly_income_f' },
    { label: '$801-$1200', value: '$801-$1200', id: 'monthly_income_g' },
    { label: '$1201-$1500', value: '$1201-$1500', id: 'monthly_income_h' },
    { label: '$1501-$2500', value: '$1501-$2500', id: 'monthly_income_i' },
    { label: '$2501-$4000', value: '$2501-$4000', id: 'monthly_income_j' },
    { label: '$4000+', value: '$4000+', id: 'monthly_income_k' }
  ],

  companyTypeOptions: [
    { label: 'form.borrow.string.companyType.bank', value: 'Bank', id: 'company_type_bank' },
    { label: 'form.borrow.string.companyType.construction', value: 'Construction - Engineering', id: 'company_type_construction' },
    { label: 'form.borrow.string.companyType.corporation_owner', value: 'Corporation Owner', id: 'company_type_corporation_owner' },
    { label: 'form.borrow.string.companyType.factory_manufacturing', value: 'Factory - Manufacturing', id: 'company_type_factory_manufacturing' },
    { label: 'form.borrow.string.companyType.fintech', value: 'Fintech', id: 'company_type_fintech' },
    { label: 'form.borrow.string.companyType.government', value: 'Government', id: 'company_type_government' },
    { label: 'form.borrow.string.companyType.import_trading', value: 'Import - Export - Trading', id: 'company_type_import_trading' },
    { label: 'form.borrow.string.companyType.insurance', value: 'Insurance', id: 'company_type_insurance' },
    { label: 'form.borrow.string.companyType.logistic_delivery', value: 'Logistic - Delivery', id: 'company_type_logistic_delivery' },
    { label: 'form.borrow.string.companyType.malls_supermarket', value: 'Malls - Supermarket', id: 'company_type_malls_supermarket' },
    { label: 'form.borrow.string.companyType.media', value: 'Media', id: 'company_type_media' },
    { label: 'form.borrow.string.companyType.medical_hospital', value: 'Medical - Hospital', id: 'company_type_medical_hospital' },
    { label: 'form.borrow.string.companyType.micro_finance', value: 'Micro Finance', id: 'company_type_micro_finance' },
    { label: 'form.borrow.string.companyType.music_entertainment', value: 'Music - Entertainment', id: 'company_type_music_entertainment' },
    { label: 'form.borrow.string.companyType.ngo', value: 'NGO', id: 'company_type_ngo' },
    { label: 'form.borrow.string.companyType.restaurant', value: 'Restaurant', id: 'company_type_restaurant' },
    { label: 'form.borrow.string.companyType.retail_shop', value: 'Retail - Shop', id: 'company_type_retail_shop' },
    { label: 'form.borrow.string.companyType.small_business_owner', value: 'Small Business Owner', id: 'company_type_small_business_owner' },
    { label: 'form.borrow.string.companyType.technology', value: 'Technology', id: 'company_type_technology' }
  ],

  relativesPersonOptions: [
    { label: 'form.borrow.relative.father', value: 'Father', id: 'father' },
    { label: 'form.borrow.relative.mother', value: 'Mother', id: 'mother' },
    { label: 'form.borrow.relative.brother', value: 'Brother', id: 'brother' },
    { label: 'form.borrow.relative.sister', value: 'Sister', id: 'sister' },
    { label: 'form.borrow.relative.relatives', value: 'Relatives', id: 'relatives' },
    { label: 'form.borrow.other', value: 'Other', id: 'relatives_other' }
  ],

  sourceOfInformationOptions: [
    { label: 'form.borrow.string.sourceOfInfo.friendAndFamily', value: 'Friend and Family', id: 'friend-and-family' },
    { label: 'form.borrow.string.sourceOfInfo.flyer', value: 'Flyer', id: 'flyer' },
    { label: 'form.borrow.string.sourceOfInfo.anotherWebsite', value: 'Another Website', id: 'another-website' },
    { label: 'form.borrow.string.sourceOfInfo.facebook', value: 'Facebook', id: 'facebook' },
    { label: 'form.borrow.string.sourceOfInfo.google', value: 'Google', id: 'google' },
    { label: 'form.borrow.string.sourceOfInfo.instagram', value: 'Instagram', id: 'instagram' },
    { label: 'form.borrow.string.sourceOfInfo.tukTukAds', value: 'Tuk Tuk Ads', id: 'tuk-tuk-ads' },
    { label: 'form.borrow.string.sourceOfInfo.byMail', value: 'By Mail', id: 'by-mail' },
    { label: 'form.borrow.string.sourceOfInfo.other', value: 'Other', id: 'sourceOfInfoOther' }
  ],

  majorOptions: [
    { label: 'form.borrow.string.major.accounting', value: 'Accounting', id: 'accounting' },
    { label: 'form.borrow.string.major.aerospaceEngineering', value: 'Aerospace Engineering', id: 'aerospaceEngineering' },
    { label: 'form.borrow.string.major.agriculture', value: 'Agriculture', id: 'agriculture' },
    { label: 'form.borrow.string.major.architecture', value: 'Architecture', id: 'architecture' },
    { label: 'form.borrow.string.major.artHistory', value: 'Art History', id: 'artHistory' },
    { label: 'form.borrow.string.major.biology', value: 'Biology', id: 'biology' },
    { label: 'form.borrow.string.major.businessManagement', value: 'Business Management', id: 'businessManagement' },
    { label: 'form.borrow.string.major.chemicalEngineering', value: 'Chemical Engineering', id: 'chemicalEngineering' },
    { label: 'form.borrow.string.major.chemistry', value: 'Chemistry', id: 'chemistry' },
    { label: 'form.borrow.string.major.chinese', value: 'Chinese', id: 'chinese' },
    { label: 'form.borrow.string.major.civilEngineering', value: 'Civil Engineering', id: 'civilEngineering' },
    { label: 'form.borrow.string.major.communications', value: 'Communications', id: 'communications' },
    { label: 'form.borrow.string.major.computerEngineering', value: 'Computer Engineering', id: 'computerEngineering' },
    { label: 'form.borrow.string.major.computerScience', value: 'Computer Science', id: 'computerScience' },
    { label: 'form.borrow.string.major.construction', value: 'Construction', id: 'construction' },
    { label: 'form.borrow.string.major.criminalJustice/Law', value: 'Criminal Justice/Law', id: 'criminalJustice' },
    { label: 'form.borrow.string.major.economics', value: 'Economics', id: 'economics' },
    { label: 'form.borrow.string.major.education', value: 'Education', id: 'education' },
    { label: 'form.borrow.string.major.electricalEngineering', value: 'Electrical Engineering', id: 'electricalEngineering' },
    { label: 'form.borrow.string.major.english', value: 'English', id: 'english' },
    { label: 'form.borrow.string.major.film', value: 'Film', id: 'film' },
    { label: 'form.borrow.string.major.finance', value: 'Finance', id: 'finance' },
    { label: 'form.borrow.string.major.graphicDesign', value: 'Graphic Design', id: 'graphicDesign' },
    { label: 'form.borrow.string.major.hospitality', value: 'Hospitality', id: 'hospitality' },
    { label: 'form.borrow.string.major.industrialEngineering', value: 'Industrial Engineering', id: 'industrialEngineering' },
    { label: 'form.borrow.string.major.informationTechnology', value: 'Information Technology', id: 'informationTechnology' },
    { label: 'form.borrow.string.major.interiorDesign', value: 'Interior Design', id: 'interiorDesign' },
    { label: 'form.borrow.string.major.internationalRelations', value: 'International Relations', id: 'internationalRelations' },
    { label: 'form.borrow.string.major.journalism', value: 'Journalism', id: 'journalism' },
    { label: 'form.borrow.string.major.managementInformationSystem', value: 'Management Information System', id: 'managementInformationSystem' },
    { label: 'form.borrow.string.major.marketing', value: 'Marketing', id: 'marketing' },
    { label: 'form.borrow.string.major.math', value: 'Math', id: 'math' },
    { label: 'form.borrow.string.major.mechanicalEngineering', value: 'Mechanical Engineering', id: 'mechanicalEngineering' },
    { label: 'form.borrow.string.major.medical', value: 'Medical', id: 'medical' },
    { label: 'form.borrow.string.major.music', value: 'Music', id: 'music' },
    { label: 'form.borrow.string.major.nursing', value: 'Nursing', id: 'nursing' },
    { label: 'form.borrow.string.major.philosophy', value: 'Philosophy', id: 'philosophy' },
    { label: 'form.borrow.string.major.physicianAssistant', value: 'Physician Assistant', id: 'physicianAssistant' },
    { label: 'form.borrow.string.major.physics', value: 'Physics', id: 'physics' },
    { label: 'form.borrow.string.major.politicalScience', value: 'Political Science', id: 'politicalScience' },
    { label: 'form.borrow.string.major.psychology', value: 'Psychology', id: 'psychology' },
    { label: 'form.borrow.string.major.religion', value: 'Religion', id: 'religion' },
    { label: 'form.borrow.string.major.sociology', value: 'Sociology', id: 'sociology' }
  ],

  occupationOptions: [
    { label: 'form.borrow.string.occupation.accountant', value: 'Accountant', id: 'accountant' },
    { label: 'form.borrow.string.occupation.administrator', value: 'Administrator', id: 'administrator' },
    { label: 'form.borrow.string.occupation.assistance', value: 'Assistance', id: 'assistance' },
    { label: 'form.borrow.string.occupation.bankTeller', value: 'Bank Teller', id: 'bankTeller' },
    { label: 'form.borrow.string.occupation.banker', value: 'Banker', id: 'banker' },
    { label: 'form.borrow.string.occupation.businessOwner', value: 'Business Owner', id: 'businessOwner' },
    { label: 'form.borrow.string.occupation.callCenter', value: 'Call Center', id: 'callCenter' },
    { label: 'form.borrow.string.occupation.carDriver', value: 'Car Driver', id: 'carDriver' },
    { label: 'form.borrow.string.occupation.ceo', value: 'CEO', id: 'ceo' },
    { label: 'form.borrow.string.occupation.chiefOfficer', value: 'Chief Officer', id: 'chiefOfficer' },
    { label: 'form.borrow.string.occupation.civilEngineer', value: 'Civil Engineer', id: 'civilEngineer' },
    { label: 'form.borrow.string.occupation.cleaner', value: 'Cleaner', id: 'cleaner' },
    { label: 'form.borrow.string.occupation.constructionWorker', value: 'Construction Worker', id: 'constructionWorker' },
    { label: 'form.borrow.string.occupation.consultant', value: 'Consultant', id: 'consultant' },
    { label: 'form.borrow.string.occupation.creditOfficer', value: 'Credit Officer', id: 'creditOfficer' },
    { label: 'form.borrow.string.occupation.dentist', value: 'Dentist', id: 'dentist' },
    { label: 'form.borrow.string.occupation.designer', value: 'Designer', id: 'designer' },
    { label: 'form.borrow.string.occupation.doctor', value: 'Doctor', id: 'doctor' },
    { label: 'form.borrow.string.occupation.electrician', value: 'Electrician', id: 'electrician' },
    { label: 'form.borrow.string.occupation.employee', value: 'Employee', id: 'employee' },
    { label: 'form.borrow.string.occupation.executive', value: 'Executive', id: 'executive' },
    { label: 'form.borrow.string.occupation.factoryWorker', value: 'Factory Worker', id: '' },
    { label: 'form.borrow.string.occupation.filmMaker', value: 'Film Maker', id: '' },
    { label: 'form.borrow.string.occupation.finance', value: 'Finance', id: '' },
    { label: 'form.borrow.string.occupation.freelancer', value: 'Freelancer', id: '' },
    { label: 'form.borrow.string.occupation.frontDesk', value: 'Front Desk', id: '' },
    { label: 'form.borrow.string.occupation.governmentEmployees', value: 'Government Employees', id: 'governmentEmployees' },
    { label: 'form.borrow.string.occupation.head', value: 'Head', id: 'Head' },
    { label: 'form.borrow.string.occupation.insuranceConsultant', value: 'Insurance Consultant', id: 'insuranceConsultant' },
    { label: 'form.borrow.string.occupation.it', value: 'IT', id: 'it' },
    { label: 'form.borrow.string.occupation.journalism', value: 'Journalism', id: 'journalism' },
    { label: 'form.borrow.string.occupation.lawyer', value: 'Lawyer', id: 'lawyer' },
    { label: 'form.borrow.string.occupation.loanCollector', value: 'Loan Collector', id: 'loanCollector' },
    { label: 'form.borrow.string.occupation.logistic', value: 'Logistic', id: 'logistic' },
    { label: 'form.borrow.string.occupation.manager', value: 'Manager', id: 'manager' },
    { label: 'form.borrow.string.occupation.marketing', value: 'Marketing', id: 'marketing' },
    { label: 'form.borrow.string.occupation.musician', value: 'Musician', id: 'musician' },
    { label: 'form.borrow.string.occupation.nurse', value: 'Nurse', id: 'nurse' },
    { label: 'form.borrow.string.occupation.onlineSeller', value: 'Online Seller', id: 'onlineSeller' },
    { label: 'form.borrow.string.occupation.operator', value: 'Operator', id: 'operator' },
    { label: 'form.borrow.string.occupation.policeOfficer', value: 'Police Officer', id: 'policeOfficer' },
    { label: 'form.borrow.string.occupation.realEstateAgent', value: 'Real Estate Agent', id: 'realEstateAgent' },
    { label: 'form.borrow.string.occupation.receptionist', value: 'Receptionist', id: 'receptionist' },
    { label: 'form.borrow.string.occupation.relationshipManagement', value: 'Relationship Management', id: 'relationshipManagement' },
    { label: 'form.borrow.string.occupation.salesperson', value: 'Salesperson', id: 'salesperson' },
    { label: 'form.borrow.string.occupation.securityWorker', value: 'Security Worker', id: 'securityWorker' },
    { label: 'form.borrow.string.occupation.singer', value: 'Singer', id: 'singer' },
    { label: 'form.borrow.string.occupation.softwareEngineer', value: 'Software Engineer', id: 'softwareEngineer' },
    { label: 'form.borrow.string.occupation.solider', value: 'Solider', id: 'solider' },
    { label: 'form.borrow.string.occupation.student', value: 'Student', id: 'student' },
    { label: 'form.borrow.string.occupation.teacher', value: 'Teacher', id: 'teacher' },
    { label: 'form.borrow.string.occupation.tourGuide', value: 'Tour Guide', id: 'tourGuide' },
    { label: 'form.borrow.string.occupation.tukTukDriver', value: 'Tuk Tuk Drivers', id: 'tukTukDriver' }
  ],

  paydayLoan: {
    amount: {
      min: 50,
      max: 200,
      warn: parseInt(process.env.VUE_APP_PAYDAY_WARN),
      interval: parseInt(process.env.VUE_APP_PAYDAY_INTERVAL)
    },
    duration: {
      min: 5,
      max: 30,
      warn: 31,
      interval: 5
    },
    display_min: process.env.VUE_APP_PAYDAY_MIN_DISPLAY,
    display_max: process.env.VUE_APP_PAYDAY_MAX_DISPLAY
  },

  personalLoan: {
    amount: {
      min: 200,
      max: 2000,
      warn: parseInt(process.env.VUE_APP_PERSONAL_LOAN_WARN),
      interval: parseInt(process.env.VUE_APP_PERSONAL_LOAN_INTERVAL)
    },
    duration: {
      min: 1,
      max: 24,
      warn: 12,
      interval: 1
    },
    display_min: process.env.VUE_APP_PERSONAL_LOAN_MIN_DISPLAY,
    display_max: process.env.VUE_APP_PERSONAL_LOAN_MAX_DISPLAY
  },

  purchasing: {
    amount: {
      min: 40,
      max: 2000,
      warn: parseInt(process.env.VUE_APP_PURCHASE_WARN),
      interval: parseInt(process.env.VUE_APP_PURCHASE_INTERVAL)
    },
    duration: {
      min: 1,
      max: 36,
      warn: 365,
      interval: 1
    },
    display_min: process.env.VUE_APP_PURCHASE_MIN_DISPLAY,
    display_max: process.env.VUE_APP_PURCHASE_MAX_DISPLAY
  },

  pawn: {
    amount: {
      min: 40,
      max: 2000,
      warn: parseInt(process.env.VUE_APP_PAWN_WARN),
      interval: parseInt(process.env.VUE_APP_PAWN_INTERVAL)
    },
    duration: {
      min: 1,
      max: 12,
      warn: 365,
      interval: 1
    },
    display_min: process.env.VUE_APP_PAWN_MIN_DISPLAY,
    display_max: process.env.VUE_APP_PAWN_MAX_DISPLAY
  },

  loan_product_id: {
    46477: '01_Pay_Day_1-9_Member',
    48506: '02_Pay_Day _1-9_Silver',
    48512: '03_Pay_Day_1-9_Gold',
    48513: '04_Pay_Day_1-9_Platinum',
    46483: '05_Pay_Day_10-14_Member',
    48507: '06_Pay_Day_10-14_Silver',
    48514: '07_Pay_Day_10-14_Gold',
    48515: '08_Pay_Day_10-14_Platinum',
    46484: '09_Pay_Day_15-19_Member',
    48508: '10_Pay_Day_15-19_Silver',
    48516: '11_Pay_Day_15-19_Gold',
    48517: '12_Pay_Day_15-19_Platinum',
    46485: '13_Pay_Day_20-24_Member',
    48509: '14_Pay_Day_20-24_Silver',
    48518: '15_Pay_Day_20-24_Gold',
    48519: '16_Pay_Day_20-24_Platinum',
    46486: '17_Pay_Day_25-29_Member',
    48510: '18_Pay_Day_25-29_Silver',
    48520: '19_Pay_Day_25-29_Gold',
    48521: '20_Pay_Day_25-29_Platinum',
    46487: '21_Pay_Day_30+_Member',
    48511: '22_Pay_Day_30+_ Silver',
    48527: '23_Pay_Day_30+_ Gold',
    48528: '24_Pay_Day_30+_ Platinum',
    43296: 'Pay Day Loan',
    43214: 'Personal Loan'
  },

  loan_disbursed_by_id: {
    32877: 'Cash',
    32878: 'ABA E-Cash',
    32879: 'Wing Transfer',
    32880: 'ABA Bank Transfer',
    34599: 'Acleda Bank Transfer'
  },

  loan_interest_method: {
    flat_rate: 'Flat Rate',
    reducing_rate_equal_installments: 'Reducing Balance - Equal Installments',
    reducing_rate_equal_principal: 'Reducing Balance - Equal Principal',
    interest_only: 'Interest-Only',
    compound_interest: 'Compound Interest'
  },

  loan_interest_period: {
    Day: 'Per Day',
    Week: 'Per Week',
    Month: 'Per Month',
    Year: 'Per Year'
  },

  loan_duration_period: {
    Days: 'Days',
    Weeks: 'Weeks',
    Months: 'Months',
    Years: 'Years'
  },

  loan_payment_scheme_id: {
    6: 'Daily',
    4: 'Weekly',
    9: 'Biweekly',
    3: 'Monthly',
    12: 'Bimonthly',
    13: 'Quarterly',
    781: 'Every 4 Months',
    14: 'Semi-Annual',
    11: 'Yearly',
    10: 'Lump-Sum'
  },

  loan_decimal_places: {
    round_off_to_two_decimal: 'Round Off to 2 Decimal Places',
    round_off_to_integer: 'Round Off to Integer',
    round_off_to_one_decimal: 'Round Off to 1 Decimal Place',
    round_up_to_one_decimal: 'Round Up to 1 Decimal Place',
    round_up_to_ten: 'Round Up to Nearest 10'
  },

  child_status_id: {
    5: 'Missed Repayment',
    6: 'Past Maturity',
    7: 'Fraud',
    10: 'Due Today',
    11: 'Investigation',
    12: 'Debt Review',
    13: 'Sequestrate',
    14: 'Write-Off',
    15: 'Legal',
    16: 'Arrears',
    18: 'Current',
    19: 'Credit Counseling',
    20: 'Collection Agency'
  },

  loan_status_id: {
    1: 'Open',
    2: 'Fully Paid',
    3: 'Defaulted',
    4: 'Restructured',
    7: '----Fraud',
    8: 'Processing',
    9: 'Denied',
    11: '----Investigation',
    12: '----Debt Review',
    13: '----Sequestrate',
    15: '----Legal',
    14: '----Write-Off',
    17: 'Not Taken Up',
    19: '----Credit Counseling',
    20: '----Collection Agency'
  }
}
